import { useSuspenseQuery } from '@apollo/client';
import {
  FETCH_REPORTING_TOOLS_PAGE,
  FetchReportingToolsPageQuery,
  FetchReportingToolsPageQueryVariables,
  ReportingToolsPage,
} from '@edwin-group/cj-graphql';
import { useReportingToolsStore } from '../store/useReportingToolsStore';
import { useEffect } from 'react';

export const useRoot = () => {
  const { data, error } = useSuspenseQuery<FetchReportingToolsPageQuery, FetchReportingToolsPageQueryVariables>(
    FETCH_REPORTING_TOOLS_PAGE,
    {
      fetchPolicy: 'cache-and-network',
    },
  );

  useEffect(() => {
    useReportingToolsStore.setState({ page: data.reportingToolsPage as ReportingToolsPage });
  }, [data]);

  return { page: data?.reportingToolsPage ?? null, error };
};
